import { FC, useContext, useEffect, useMemo, useRef, useState } from 'react'
import "./style.css"
import { Context } from '../../context'
import Table from '../table'
import { useLocation } from 'react-router-dom'
import { IReportPage } from './ReportPage.Type'
import { SkeletonTable } from '../table/TableSkeleton'



const ReportsPagesContent: FC<IReportPage> = ({ needParams = false, children, tableAPI, columns, renderRowSubComponent, onDataLoad }) => {

    const [data, setData] = useState([])
    const [isFirstLoad, setIsFirstLoad] = useState(true)
    const [TotalRows, setTotalRows] = useState(0)
    const [hiddenColumnsList, setHiddenColumnsList] = useState<any[]>()

    const [tableFiller, setTableFiller] = useState({ PageSize: 25, page: 0 })


    const fetchIdRef = useRef(0)

    const { setDataLoading, dataLoading, setSearchData, searchData, customSearchData, setCustomSearchData, setSearchTypes } = useContext(Context)
    const { reloadTable } = useContext(Context)

    const { pathname } = useLocation()

    const currentPage = useRef('')

    const FieldsSearchData = useMemo(() => {

        let searchObject: any = {}
        searchData.forEach((item: any) => {
            searchObject[`${item.accessor}`] = item.value
        })

        return searchObject

    }, [searchData])

    useEffect(() => {
        let searchFields: any[] = []
        let customSearch: any = {}
        let hiddenColumns: any[] = []

        columns.forEach((element) => {
            if (element?.canSearch && !element?.type) searchFields.push(
                {
                    accessor: element.accessor,
                    label: `${element?.label || element?.accessor}`,
                    value: ""
                }
            );
            if (element?.canSearch && element?.type != null) {
                customSearch[element.accessor] = {
                    type: element?.type,
                    depArr: element?.depArr,
                    apiSource: element?.sourceApi,
                    isMulti: element?.isMulti,
                    Header: element?.Header,
                    selectFirst: element?.selectFirst,
                    accessor: element?.accessor,
                    options: element?.options,
                    probName: element?.probName,
                    sourceId: element?.sourceId
                }
            }

            if (element["visible"] == false) {
                hiddenColumns.push(element["accessor"])
            }
        });

        setHiddenColumnsList(hiddenColumns)
        setSearchTypes((prev: any) => customSearch)
        setSearchData((prev: any) => searchFields || [])
    }, [])

    const FetchData = (tableSearchData: any) => {
        const fetchId = ++fetchIdRef.current
        setDataLoading((l: number) => l + 1)

        tableAPI(tableSearchData, tableFiller).then((result: { data: { success: boolean, data: [], totalCount: number } }) => {
            setDataLoading((l: number) => l - 1)
            if (fetchId === fetchIdRef.current && result.data.success) {
                setData(result.data.data || [])
                setTotalRows(result.data.totalCount)
                setIsFirstLoad(false)
                onDataLoad?.(result.data.data)
            }
        }).catch(() => {
            setDataLoading((l: number) => l - 1)
        })
    }

    useEffect(() => {
        if ((needParams && isFirstLoad))
            return

        let tableSearchData = isFirstLoad ? {} : { ...FieldsSearchData, ...customSearchData };
        FetchData(tableSearchData)

    }, [reloadTable, tableFiller])

    useEffect(() => {
        if (currentPage.current != pathname) {
            setCustomSearchData({})
            currentPage.current = pathname
            return
        }

        if (needParams && Object.entries(customSearchData).length == 0 || !isFirstLoad)
            return setIsFirstLoad(false)
        let tableSearchData = { ...FieldsSearchData, ...customSearchData };
        FetchData(tableSearchData)

    }, [reloadTable, tableFiller, needParams, customSearchData])

    return (
        <div className='pages-wrapper'>
            {children}

            {!dataLoading ?
                <Table
                    columns={columns}
                    data={data}
                    setTableFiller={setTableFiller}
                    tableFiller={tableFiller}
                    TotalRows={TotalRows}
                    hiddenColumns={hiddenColumnsList}
                    renderRowSubComponent={renderRowSubComponent}
                />
                :
                <SkeletonTable />
            }
        </div>
    )
}

export default ReportsPagesContent